module.exports = __webpack_public_path__ + "img/thumbnail_HermannsTortoise_u_normal.a16dfbab.png";